<template>
    <div>
        <el-form ref="searchForm" :inline="true" :model="searchForm" @submit.native.prevent class="forTbFilter">
            <el-form-item label="代理商名称：">
                <el-input v-model.trim="searchForm.name"  @keyup.enter.native="getAgentAccountListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" plain icon="el-icon-search" @click="getAgentAccountListHandler">搜索</el-button>
                <el-button type="success" plain icon="el-icon-plus" @click="showPrechargeForAgent">充值</el-button>
                <el-button type="danger" plain  @click="showChangePrechargePwd" icon="el-icon-edit">修改充值密码</el-button>
            </el-form-item>
        </el-form>
        <el-table  
			:data="tbpg.tableData"
			border
			fit
			highlight-current-row
			style="width: 100%;"
			:header-cell-style="{background:'#f5f5f5'}"
		>
            <el-table-column align="center" type="index" label="序号" width="50"></el-table-column>
            <el-table-column align="center" prop="name" label="代理商名称"></el-table-column>
            <el-table-column align="center" prop="totalHistoryRmb" label="充值金额（元）"></el-table-column>
            <el-table-column align="center" prop="balanceRmb" label="剩余金额（元）"></el-table-column>
            <el-table-column align="center" prop="usedBalanceRmb" label="消费金额（元）"></el-table-column>
            <el-table-column align="center" prop="createOptName" label="创建人"></el-table-column>
            <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="showDecPrechargeAmount(scope.row)">
						<span style="color: #67c23a;">
							余额修改
						</span>
					</el-button>
                    <el-button type="text" size="mini" @click="getPrechargeDetailHandler(scope.row.sysAgentAccountId, $event)">充值详情</el-button>
                </template>
            </el-table-column>
        </el-table>
		<!-- 分页 -->
		<div class="pagination-container">
		  <el-pagination
		    :current-page="tbpg.currentPage"
		    :page-sizes="[10,20,500,2000,5000,10000]"
		    :page-size="tbpg.pageSize"
		    :total="tbpg.total"
		    background layout="total, sizes, prev, pager, next, jumper"
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		  />
		</div>
        <el-dialog :append-to-body="true"  title="充值" :visible.sync="prechargeVisible" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="prechargeForm" :model="prechargeForm" :rules="prechargeRules" label-width="100px">
                <el-form-item label="代理商：" prop="agentId">
                    <el-select v-model="prechargeForm.agentId" filterable>
                        <el-option v-for="item in agentListOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>  
                </el-form-item>
                <el-form-item label="充值金额：" prop="priceRmb">
                    <el-col :span="22">
                        <input class="input-defined" v-model="prechargeForm.priceRmb" @keyup="formatPrice()" 
                        @blur="formatPrice()" placeholder="请输入充值金额"></input>
                    </el-col>
                    <el-col :span="2" class="center">元</el-col>
                </el-form-item>
                <el-form-item label="操作密码："  prop="password">
                    <el-input v-model.trim="prechargeForm.password" type="password" show-password clearable></el-input>
                </el-form-item>
                <el-form-item label="备注：">
                    <el-input type="textarea" v-model="prechargeForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="surePrechargeForAgent">确 定</el-button>
            </div>            
        </el-dialog>        
        <el-dialog :append-to-body="true"  title="修改余额" :visible.sync="decreaseVisible" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="decreaseForm" :model="decreaseForm" :rules="decreaseRules" label-width="100px">
                <el-form-item label="减扣金额：" prop="decPriceRmb">
                    <el-col :span="22">
                        <input class="input-defined" v-model="decreaseForm.decPriceRmb" @keyup="formatDecPriceRmb()" 
                        @blur="formatDecPriceRmb()" placeholder="请输入减扣金额"></input>
                    </el-col>
                    <el-col :span="2" class="center">元</el-col>
                </el-form-item>
                <div class="lineInDialog">
                    <label>充值金额：</label>
                    <span>{{ decreaseForm.totalHistoryRmb }} 元</span>
                </div>
                <div class="lineInDialog">
                    <label>剩余金额：</label>
                    <span>{{ decreaseForm.balanceRmb }} 元</span>
                </div>
                <el-form-item label="修改描述：">
                    <el-input type="textarea" v-model="decreaseForm.remark"></el-input>
                </el-form-item>
                <el-form-item label="操作密码：" prop="password">
                    <el-input v-model.trim="decreaseForm.password" type="password" show-password clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="decreaseVisible = false">取 消</el-button>
                <el-button type="primary" @click="sureDecPrechargeAmountHandler">确 定</el-button>
            </div>            
        </el-dialog>
        <el-dialog :append-to-body="true"  title="修改充值密码" :visible.sync="editPwdVisible" width="600px" :close-on-click-modal="false">
            <el-form ref="editPwdForm" :model="editPwdForm" label-width="100px">
                <el-form-item label="老密码：">
                    <el-input v-model.trim="editPwdForm.oldPwd" type="password" show-password clearable></el-input>
                </el-form-item>
                <el-form-item label="新密码：">
                    <el-input v-model.trim="editPwdForm.newPwd" type="password" show-password clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editPwdVisible = false">取 消</el-button>
                <el-button type="primary" @click="sureChangePrechargePwdHandler">确 定</el-button>
            </div>            
        </el-dialog>
        <el-dialog :append-to-body="true"  title="充值记录" :visible.sync="prechargeAllVisible" width="1000px" :close-on-click-modal="false">
            <el-table :data="tbpg_pre.tableData" border height="421">
                <el-table-column prop="accountBalanceRmb" label="账户余额（元）" width="120px"></el-table-column>
                <el-table-column prop="amountRmb" label="交易金额（元）" width="120px"></el-table-column>
                <el-table-column prop="createTime" label="交易时间" width="180px"></el-table-column>
                <el-table-column prop="ioTypeName" label="类型" width="100px"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="tbpg_pre.currentPage"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="tbpg_pre.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tbpg_pre.total">
            </el-pagination>             
        </el-dialog>
    </div>
</template>

<script>
import {getAgentAccountList, getPrechargeDetail, prechargeForAgent, decreasePrechargeAmount, changePrechargePwd} from '@/api/order.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                name: ''
            },
            prechargeVisible: false,
            prechargeForm: {
                agentId: '',
                priceRmb: '',
                password: '',
                remark: ''
            },
            agentListOption: [],            
            decreaseVisible: false,
            decreaseForm: {
                id: '',
                decPriceRmb: '',
                totalHistoryRmb: '',
                balanceRmb: '',
                remark: '',
                password: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            prechargeAllVisible: false,    
            currentId_pre: '', 
            tbpg_pre: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0                
            },           
            editPwdVisible: false,     //修改充值密码
            editPwdForm: {
                oldPwd: '',
                newPwd: ''
            },
            prechargeRules: {
                agentId: [{required: true, message: '请选择代理商', trigger: 'blur'}],
                priceRmb: [
                    {required: true, message: '请输入充值金额', trigger: 'blur'}
                ],
                password: [{required: true, message: '请输入操作密码', trigger: 'blur'}]
            },
            decreaseRules: {
                decPriceRmb: [
                    {required: true, message: '请输入扣减金额', trigger: 'blur'}
                ],
                password: [{required: true, message: '请输入操作密码', trigger: 'blur'}]
            }
        }
    },
    methods: {
        cancel(){
            this.prechargeVisible = false;   
            this.$refs.prechargeForm.resetFields(); 
        },
        formatPrice(){
            let str = this.prechargeForm.priceRmb.toString();
            this.prechargeForm.priceRmb = str.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
        },
        formatDecPriceRmb(){
            let str = this.decreaseForm.decPriceRmb.toString();
            this.decreaseForm.decPriceRmb = str.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
        },
        getAgentAccountListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);

            getAgentAccountList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        getPrechargeDetailHandler(id, $event){
            this.prechargeAllVisible = true;
            this.currentId_pre = id;
            var searchForm = {
                accountId: this.currentId_pre  
            }
            common.resetCurrentPage(this, $event, 'tbpg_pre');
            var data = common.getRequestParams(this, 'tbpg_pre', searchForm);
            getPrechargeDetail(data).then(res => {
                common.listCallback(this, res, 'tbpg_pre');
            })
        },     
        showPrechargeForAgent(){
            this.prechargeVisible = true;
            common.getAgentListOptionCom1(this, 'agentListOption');
        },
        surePrechargeForAgent(){
            this.$refs.prechargeForm.validate(valid => {
                if(valid){
                    var data = this.prechargeForm;
                    prechargeForAgent(data).then(res => {
                        if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.prechargeVisible = false;
                            this.getAgentAccountListHandler();                
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }
            }) 
        },
        showDecPrechargeAmount(row){
            this.decreaseVisible = true;
            this.decreaseForm = row;
        },
        sureDecPrechargeAmountHandler(){
            this.$refs.decreaseForm.validate(valid => {
                if(valid){
                    var data = {
                        agentId: this.decreaseForm.id,
                        priceRmb: this.decreaseForm.decPriceRmb,
                        remark: this.decreaseForm.remark,
                        password: this.decreaseForm.password
                    }
                    decreasePrechargeAmount(data).then(res => {
                        if(res.data.code == 200){
                            this.decreaseVisible = false;
                            this.getAgentAccountListHandler();
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }
            })
        },
        showChangePrechargePwd(){
            this.editPwdVisible = true;
        },
        sureChangePrechargePwdHandler(){
            var data = this.editPwdForm;
            changePrechargePwd(data).then(res => {
                if(res.data.code == 200){
                    this.editPwdVisible = false;
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        handleSizeChange(val){
            if(this.prechargeAllVisible){
                this.tbpg_pre.pageSize = val;
                this.getPrechargeDetailHandler(this.currentId_pre);
            }else{
                this.tbpg.pageSize = val;
                this.getAgentAccountListHandler();
            }
        },
        handleCurrentChange(val){
            if(this.prechargeAllVisible){
                this.tbpg_pre.currentPage = val;
                this.getPrechargeDetailHandler(this.currentId_pre);
            }else{
                this.tbpg.currentPage = val;
                this.getAgentAccountListHandler();
            }
        }
    },
    created(){
        this.getAgentAccountListHandler();
    }
}
</script>

<style lang="less" scoped>
.input-defined{
    position: relative;
    height: 32px;
    font-size: 14px;
    display: inline-block;
    width: 100%;
    outline: 0;
    box-sizing: border-box;
    color: #606266;
    padding-left: 10px;
    border-radius: 4px;
    border: 1px solid #DCDFE6;

}

</style>

